module.exports = __webpack_public_path__ + "static/media/art3.775236c6.png";